'use strict';

module.exports = function formatDPH(element, data, context) {
    var elementData = data && data[element.id];
    element.name = elementData.tagName;
    return context.renderTag(element, data, context);
};
